import React from 'react';
import styled, { keyframes } from 'styled-components';

/**
 * Loading component specifically for the interim period between when Plaid token
 * is fetched and when Plaid's iframe takes over. Prevents user interactions
 * by covering the entire viewport with an overlay that matches Plaid's styling.
 */
export function PlaidInterimLoader(): JSX.Element {
  return <LoaderOverlay />;
}

const rot = keyframes`
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
`;

const LoaderOverlay = styled.div`
  display: flex;
  box-sizing: border-box;
  justify-content: center;
  align-items: center;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  height: 100vh;
  color: #4b4b4b;
  transition: opacity 350ms ease-out 0.1s;
  opacity: 1;
  z-index: 9999;

  /* Prevent any interactions behind the loader */
  pointer-events: all;
  user-select: none;

  &::after {
    content: '';
    animation: ${rot} 1.2s infinite cubic-bezier(0.23, 1.2, 0.32, 1);
    border-bottom: 2px solid #ebebeb;
    border-left: 2px solid #ebebeb;
    border-radius: 100%;
    border-right: 2px solid #ebebeb;
    border-top: 2px solid #949494;
    box-sizing: border-box;
    height: 45px;
    margin: 0 0 45px;
    padding: 0;
    width: 45px;
  }
`;
